import styled from 'styled-components';
import { Link } from '@atlassian/help-center-common-component/analytics/link';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';

export const FormLink = styled(Link)`
    color: ${(props) => token('color.link', props.theme.color)};
`;

export const Description = styled.div`
    ${mixins.clamp};
`;
